import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'attFilter',
  pure: false,
})
export class AttributesFilterPipe implements PipeTransform {
  transform(attributes: any[], filterType: string): any {
    if (!attributes || !filterType) {
      return attributes;
    }

    return attributes.filter((item) => item.type.indexOf(filterType) !== -1 && !item.isHidden);
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/sxfdesigner/pipes/attributes-filter.pipe.ts